module.exports = __webpack_public_path__ + "media/bootstrap-icons/journal-x-cc981875.svg";